import SiteLogo from "@/components/SiteLogo";
import { Link } from "react-router-dom";

const TopInfo: React.FC = () => {
    return (

        <section className="topInfoSection page_toplogo cs table_section table_section_md" >
            <div className="container">
                <div className="row">
                    <div className="col-md-4 col-lg-3 logoContainer">
                        <Link to="./" className="logo">
                            <SiteLogo size="smallHeader" />
                            {/* <span className="logo_text">
                                <span className="highlight kanit bold">Güneş Sinai Gaz</span><br />
                            </span> */}
                        </Link>
                    </div>

                    <div className="col topInfoRightRow">
                        <div className="row">
                            <div className="TopInfoAddress">
                                <div className="col-md-4 col-lg-4 text-center text-md-left hidden-md">
                                    <div className="media thin_teaser inline-block">
                                        <div className="media-left media-middle">
                                            <div className="teaser_icon teaserBorderIcon border_icon round">
                                                <i className="icon-map-marker highlight" />
                                            </div>
                                        </div>
                                        <div className="media-body media-middle">
                                            <p className="kanit mediaBodyTextSize text-uppercase bold fontsize_12">
                                                İzmir Merkez,
                                                <br />
                                                <span>2797 Sok. No:6
                                                </span>
                                                <br />
                                                <i className="" /><span>  +90 232 435 70 69</span>
                                                <br />
                                                <i className="" /> <span>  +90 232 486 98 99</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2 col-lg-4 text-center text-md-left hidden-md">
                                    <div className="media thin_teaser inline-block">
                                        <div className="media-left media-middle">
                                            <div className="teaser_icon teaserBorderIcon border_icon round">
                                                <i className="icon-map-marker highlight" />
                                            </div>
                                        </div>
                                        <div className="media-body media-middle">
                                            <p className="kanit mediaBodyTextSize text-uppercase bold fontsize_12">
                                                Manisa Şube,
                                                <br />
                                                <span>Evranos Mahallesi Küme Evleri No:20
                                                </span>
                                                <br />
                                                <i className="" /><span> +90 236 214 01 95</span>
                                                <br />
                                                <i className="" /> <span> +90 232 214 01 98 </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default TopInfo;